import React, {useMemo} from "react"
import BaseTextInput from "./BaseTextInput"
import RegularNumberFormatter from "./RegularNumberFormatter"
import {validateFloatingChars} from "./bloom-utils/validations"
import EuroIcon from "../../assets/images/euroicon.svg"
import {deNumberStringToNumber} from "../../misc/utils"
import {Box, Typography} from "@mui/material"

export const widgetInputCurrencyPrototype = [
    {
        key: "infotext",
        type: "STRING",
        label: "infotext",
        size: 6,
    },
]

const WidgetInputCurrency = (props) => {
    const {
        disableEndAdornment = false,
        infoText,
        text,
        disabled,
        ...rest
    } = props

    const onValueChange = (value) => {
        props.onValueChange(deNumberStringToNumber(value))
    }

    const percentProps = useMemo(
        () => ({
            onChangeValidations: [validateFloatingChars],
            endAdornment: disableEndAdornment ? null : <EuroIcon />,
            inputProps: {
                decimalScale: 2,
                fixedDecimalScale: true,
                inputMode: "decimal",
            },
            inputComponent: RegularNumberFormatter,
        }),
        [disableEndAdornment],
    )

    return (
        <Box>
            {(text || infoText) && (
                <Box
                    display="flex"
                    alignItems="center"
                    gap={1}>
                    {text && (
                        <Typography className={disabled ? "disabled" : ""}>
                            {text}
                        </Typography>
                    )}
                </Box>
            )}

            <BaseTextInput
                {...rest}
                {...percentProps}
                onValueChange={onValueChange}
                disabled={disabled || props.widget.disabled}
            />
        </Box>
    )
}

export default WidgetInputCurrency
